export default process.env.NODE_ENV === 'production' ? 'https://scoli.verdedata.ro' : 'http://localhost:2655'
// export default process.env.NODE_ENV === 'production' ? 'https://verdeshares1.verdedata.ro' : 'http://localhost:2555'
// export default process.env.NODE_ENV === 'production' ? 'https://lifturi-s6.dragos.club' : 'http://localhost:6555'
